import { request } from 'graphql-request';
import { API_URL, EVENT_TOKEN } from 'appenv';

const confirmationEmailResendMutation = `
  mutation confirmationEmailResend($eventToken: String!, $email: String!) {
    confirmationEmailResend(input: {
      eventToken: $eventToken,
      email: $email
    }) {
      success
    }
  }
`;

function confirmationEmailResend(email) {
  return request(API_URL, confirmationEmailResendMutation, {
    eventToken: EVENT_TOKEN,
    email,
  }).then((result) => result.confirmationEmailResend).catch(() => ({ success: false }));
}

export default confirmationEmailResend;
